module.exports = __WEBPACK_EXTERNAL_MODULE__824__;